import { useState } from "react";
import { t } from "../../i18n";

export function OrganizationInviteForm({
  onInvite,
}: {
  onInvite: (input: {
    name: string;
    email: string;
    role: string;
  }) => Promise<void>;
}) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("member");
  return (
    <div className="mt-4 grid gap-3 border-t border-stone-200 pt-4 sm:grid-cols-4 dark:border-white/10">
      <input
        className="field"
        placeholder={t("Name")}
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
      <input
        className="field"
        type="email"
        placeholder={t("Email")}
        value={email}
        onChange={(event) => setEmail(event.target.value)}
      />
      <select
        className="field"
        value={role}
        onChange={(event) => setRole(event.target.value)}
      >
        <option value="member">{t("Member")}</option>
        <option value="admin">{t("Administrator")}</option>
        <option value="automation_manager">{t("Automation manager")}</option>
        <option value="connection_manager">{t("Connection manager")}</option>
        <option value="billing_admin">{t("Billing administrator")}</option>
        <option value="owner">{t("Owner")}</option>
      </select>
      <button
        className="button-primary"
        disabled={!name || !email}
        onClick={() =>
          void onInvite({ name, email, role }).then(() => {
            setName("");
            setEmail("");
          })
        }
      >
        {t("Invite member")}
      </button>
    </div>
  );
}
